var _ = Object.defineProperty, j = Object.defineProperties;
var D = Object.getOwnPropertyDescriptors;
var l = Object.getOwnPropertySymbols;
var f = Object.prototype.hasOwnProperty, y = Object.prototype.propertyIsEnumerable;
var d = (r, s, o) => s in r ? _(r, s, { enumerable: !0, configurable: !0, writable: !0, value: o }) : r[s] = o, i = (r, s) => {
  for (var o in s || (s = {}))
    f.call(s, o) && d(r, o, s[o]);
  if (l)
    for (var o of l(s))
      y.call(s, o) && d(r, o, s[o]);
  return r;
}, v = (r, s) => j(r, D(s));
var n = (r, s) => {
  var o = {};
  for (var e in r)
    f.call(r, e) && s.indexOf(e) < 0 && (o[e] = r[e]);
  if (r != null && l)
    for (var e of l(r))
      s.indexOf(e) < 0 && y.call(r, e) && (o[e] = r[e]);
  return o;
};
import { jsx as F } from "react/jsx-runtime";
import { r as O } from "./rem-CMQJ_ZTp.js";
import "react";
import { g as V } from "./OptionalPortal-Di7MceI_.js";
import { e as Z } from "./get-size-BzhHC8s2.js";
import { c as $ } from "./create-vars-resolver-Bzbn9G-G.js";
import { b, B as q, r as w } from "./factory-BnRIVbT0.js";
import { u as A } from "./use-styles-CB9_o8RJ.js";
import { p as C } from "./polymorphic-factory-CU4yDpSd.js";
var c = { root: "m_9814e45f" };
const E = {
  zIndex: V("modal")
}, G = $(
  (r, { gradient: s, color: o, backgroundOpacity: e, blur: a, radius: m, zIndex: t }) => ({
    root: {
      "--overlay-bg": s || (o !== void 0 || e !== void 0) && w(o || "#000", e != null ? e : 0.6) || void 0,
      "--overlay-filter": a ? `blur(${O(a)})` : void 0,
      "--overlay-radius": m === void 0 ? void 0 : Z(m),
      "--overlay-z-index": t == null ? void 0 : t.toString()
    }
  })
), u = C((r, s) => {
  const o = b("Overlay", E, r), p = o, {
    classNames: e,
    className: a,
    style: m,
    styles: t,
    unstyled: g,
    vars: x,
    fixed: h,
    center: N,
    children: R,
    radius: H,
    zIndex: J,
    gradient: K,
    blur: L,
    color: M,
    backgroundOpacity: Q,
    mod: S
  } = p, B = n(p, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "fixed",
    "center",
    "children",
    "radius",
    "zIndex",
    "gradient",
    "blur",
    "color",
    "backgroundOpacity",
    "mod"
  ]), P = A({
    name: "Overlay",
    props: o,
    classes: c,
    className: a,
    style: m,
    classNames: e,
    styles: t,
    unstyled: g,
    vars: x,
    varsResolver: G
  });
  return /* @__PURE__ */ F(q, v(i(v(i({ ref: s }, P("root")), { mod: [{ center: N, fixed: h }, S] }), B), { children: R }));
});
u.classes = c;
u.displayName = "@mantine/core/Overlay";
export {
  u as O
};
